module.exports = __webpack_public_path__ + "img/KRB.dcd55505.svg";